<template>
<div class="featureTab">
    <fg-input type="search" :placeholder="$t('button.search')" v-model.lazy="filter.text" addon-left-icon="fa fa-search"></fg-input>
    <SelectList :options="this.typeSearchOptions" value="NOFILTER" @select="(val)=>this.filter.typeOption = val" />
   <!-- <SelectList :options="this.typeSearchOptions" value="NOFILTER" @select="(val)=>this.filter.typeOption = val" :label="$t('map.route_tab.route_vehicle_type')"/> -->
    <hr>
    <div id="itemListBase" ref="itemListBase" >
      <div id="itemList">
        <template v-for="(item) in this.printedList">
          <MapRouteEntry :entry="item" :key="item.tunnus" @click="selectedItem"></MapRouteEntry>
        </template>
      </div>
    </div>
    <div id="paginat" v-if="totalRows > listLimit">
      <b-pagination
        class="map-pagination"
        v-model="currentPage"
        :total-rows="this.totalRows"
        :per-page="this.listLimit"
        align="fill"
        first-number
        last-number
        limit="2">
      </b-pagination>
    </div>

    <transition name="slide">
      <div class="slidein" v-if="item">
        <MapRouteDetails v-if="this.item" :key="this.item.tunnus" :itemId="this.item.tunnus" @hideItemDetails="hideDetails"></MapRouteDetails>
      </div>
    </transition>
</div>
</template>
<style scoped lang="scss">
div.featureTab {
  max-height: 90%;
  display: flex;
  flex-direction: column;

  #itemListBase {
    display:flex;
    flex-flow: column;
    overflow: auto;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}
#itemList {
  flex-grow:4;
}

#paginat {
  order: 99;
}
</style>

<script>
import mapstore from '@/store/map/mapstore'
import MapRouteEntry from '@/components/Map/MapRouteEntry'
import MapRouteDetails from '@/components/Map/MapRouteDetails'

export default {
  name: 'Routes',
  components: {
    MapRouteEntry,
    MapRouteDetails
  },
  props: {
   // msg: String
  },
  data: function() {
    return {
      routeList: null,
      currentPage: 1,
      listLimit:  30,
      item: null,
      typeSearchOptions: [{id: "NOFILTER", label: this.$t("map.vehicles_tab.filter_no_filter"), icon: 'filter'}],
      filter: {
        text: "",
        typeOption: "NOFILTER"
      }
    }
  },
  beforeCreate: function() {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
  },
  watch: {
    filter: {
      deep: true,
      handler(newFilter) {
        //console.log("filtteröity");
        this.$store.commit('mapstore/setRouteFilter',newFilter);
        this.updateData();
	setTimeout(this.tuneListLenght,200); 
        this.$emit("filterUpdated");
      }
    }
  },
  computed: { 
      totalRows() {
        return this.routeList ? this.routeList.length : 0;
      },
      printedList() {
        var begin = (this.currentPage-1)*this.listLimit;
        var end = begin + this.listLimit;
        return this.routeList ? this.routeList.slice(begin,end) : [];
      },
  },
  mounted: function() {
    this.updateData();
    this.getTypeSearchOptions();
  },
  methods : {
    listOverflows: function() {
      try {
        let elem = this.$refs.itemListBase;
        let result = elem.scrollHeight > elem.clientHeight;
        return result;
      }catch(err) {
        return false;
      }
    },
    tuneListLenght: function() {
      if(this.listOverflows()) {
        this.listLimit = this.listLimit -1;
        setTimeout(this.tuneListLenght,100); 
      }
    },
    selectedItem(tunnus) {
      var selected = this.routeList.filter(i => i.tunnus == tunnus);
      this.item = selected[0];
      this.$emit("routeSelected", this.item);
    },
    hideDetails() {
      this.item = null;
      this.$emit('detailsClosed');
    },
    updateData() {
      let $vm = this;
      this.$store.dispatch('mapstore/getRoutesForTable').then((data) => {
        $vm.routeList = JSON.parse(JSON.stringify(data));
	setTimeout(this.tuneListLenght,200); 
      },()=>{ this.$travellerGetDataError();});
    },
    getTypeSearchOptions() {
      this.$store.dispatch('mapstore/getRouteTypes').then((types) => {
        //var types = this.$store.getters['mapstore/getRouteTypes'];
        var options = [];
        //options.push({id: "NOFILTER", label:this.$t("map.vehicles_tab.filter_no_filter"), icon: "filter"});
        options.push({id: "NOFILTER", label: this.$t("filter.no"), icon: "filter", caption: this.$t("map.route_tab.route_vehicle_type")});

        types.forEach(l => {
          var option = {id: ""+l, label: ""+l, icon: null};
          options.push(option);
        });
  
        options.sort( (a, b) =>{
          if(a.id == "NOFILTER" || a.id == null) {
            return -1;
          } else if(b.id == "NOFILTER" || b.id == null) {
            return 1;
          }
          return a.id.localeCompare(b.id);
        });
        this.typeSearchOptions = options;
      });
    }
  }
}
</script>


